import { FILTER_ENUMS, SORT } from 'search/enums/constants';
import { TIMELINE_PATHNAME } from 'timeline/enums/constants';

export const getIsSortActive = (activeView, router) => {
  const { pathname, query } = router;
  const { recently_released: recentlyReleased, release_date: releaseDate, sortBy } = query;
  const isTimelinePath = pathname === TIMELINE_PATHNAME;
  const isActiveViewSort = activeView === SORT;
  const isRecentlyReleasedSelected = recentlyReleased;

  if (releaseDate) {
    return isTimelinePath
      ? sortBy === FILTER_ENUMS.RELEASE_DATE
      : !(sortBy === FILTER_ENUMS.RELEASE_DATE);
  }

  return isActiveViewSort || isRecentlyReleasedSelected || sortBy;
};
